export default {"src":"/_next/static/media/quickapproval.abefe9b6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};